import { createSlice } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../SliceKeys'
import { HubState } from './HubSliceModels'

export const initialHubState: HubState = {
   isConnected : false,
   isUserLogged : false
}



export const hubSlice = createSlice({
   name: SLICE_KEYS.HUB_SLICE,
   initialState: initialHubState,
   reducers: {
      hubConnected: (state) => {
         state.isConnected = true
      },
      hubDisconnected: (state) => {
         state.isConnected = false
      },
      hubUserLogged: (state) => {
         state.isUserLogged = true
      },
   }  
 })
 
 // Action creators are generated for each case reducer function
 export const { hubConnected, hubDisconnected, hubUserLogged } = hubSlice.actions
 
 export default hubSlice.reducer